import React from 'react';
import styles from './ui/Input/Input.module.css';

interface YearDropDownProps {
  selectedYear: number | null;
  onYearChange: (year: number) => void;
  yearOptions: number[];
  className?: string;
  style?: React.CSSProperties;
}

const YearDropDown: React.FC<YearDropDownProps> = ({
  selectedYear,
  onYearChange,
  yearOptions,
  className = '',
  style = {}
}) => {
  return (
    <div 
      style={{ 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "flex-end", 
        marginBottom: "1rem",
        ...style 
      }}
      className={className}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}>
        <label htmlFor="YearDropDown" style={{ fontWeight: 500 }}>Year:</label>
        <select
          id="YearDropDown"
          className={styles.singleInput}
          style={{ width: "120px" }}
          value={selectedYear ?? (yearOptions[0] as number)}
          onChange={(e) => {
            const year = Number(e.target.value);
            onYearChange(year);
          }}
        >
          {yearOptions.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default YearDropDown;